import React from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';
import cs from 'clsx';

const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

const Loading = ({ className }: { className?: string }) => {
  return (
    <div className={cs('flex items-center justify-center', className)}>
      <Spin indicator={antIcon} />
    </div>
  );
};

export default Loading;
